import React from 'react';

import PropTypes from 'prop-types';
import DisableButton from './components/disable';

import { BlockItemContainer, BlockItemHead, BlockTitle } from '../../css';
import FormControlPanel from './components/formControlPanel';

const BlockItem = ({ data, fetchData }) => {
  const { id, name, description, formTypes, isDeleted } = data;
  return (
    <BlockItemContainer isDisabled={isDeleted}>
      <BlockItemHead>
        <BlockTitle isDisabled={isDeleted}>{description}</BlockTitle>
        <div>
          <DisableButton
            id={id}
            name={name}
            description={description}
            fetchData={fetchData}
            isDeleted={isDeleted}
          />
        </div>
      </BlockItemHead>
      <FormControlPanel
        id={id}
        formTypes={formTypes}
        isDeleted={isDeleted}
        fetchData={fetchData}
      />
    </BlockItemContainer>
  );
};

BlockItem.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    description: PropTypes.string,
    formTypes: PropTypes.shape({
      disableBrp: PropTypes.bool,
      disableReferral: PropTypes.bool,
      disableWireless: PropTypes.bool,
      disableWireline: PropTypes.bool
    }),
    isDeleted: PropTypes.bool
  }).isRequired,
  fetchData: PropTypes.func.isRequired
};

export default BlockItem;
